// internal
import { axios, def, storage, handleResponse, handleError } from './internal';

function FilterSearchList(service, groupFlags, onSuccess) {
    const path = `${service}.filter`;
    storage.transience.setState(`${path}.loading`, true);

    axios
        .post('/api/filter_search_list', { service, groupFlags })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const { filters } = res.data.data;
                    storage.transience.setState(`${path}.data`, filters);
                    onSuccess?.(filters);
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            storage.transience.setState(`${path}.loading`, false);
        });
}

export { FilterSearchList };
